import { IOrder } from '../../types/Order';
import { IEscrowMember, ISigner } from '../../types/Parties';
import { moveToStart } from './helpers';

export const mergeOrderUpdates = (
  updatedOrder: IOrder,
  currentOrder: IOrder
) => {
  return new Promise((resolve) => {
    const mergedOrderDetails = { ...updatedOrder };
    mergedOrderDetails.Id = currentOrder.Id;
    mergedOrderDetails.VersionNumber = currentOrder?.VersionNumber;
    mergedOrderDetails.OrderDetails = { ...currentOrder.OrderDetails };
    mergedOrderDetails.CreatedAt = currentOrder.CreatedAt;
    mergedOrderDetails.CreatedBy = currentOrder.CreatedBy;
    mergedOrderDetails.Emails = currentOrder.Emails;
    mergedOrderDetails.ModifiedAt = currentOrder.ModifiedAt;
    mergedOrderDetails.ModifiedBy = currentOrder.ModifiedBy;
    mergedOrderDetails.SearchField = currentOrder.SearchField;
    mergedOrderDetails.SignerNames = currentOrder.SignerNames;
    mergedOrderDetails.Status = currentOrder.Status;

    if (
      currentOrder.OrderOverview?.Signers &&
      currentOrder.OrderOverview.Signers.length
    ) {
      for (let i = 0; i < currentOrder.OrderOverview.Signers.length; i++) {
        if (currentOrder.OrderOverview.Signers[i].Id?.includes('custom')) {
          mergedOrderDetails.OrderOverview?.Signers?.push(
            currentOrder.OrderOverview.Signers[i]
          );
        }
      }
    }

    if (
      currentOrder.OrderOverview?.EscrowTeam &&
      currentOrder.OrderOverview.EscrowTeam.length
    ) {
      for (let i = 0; i < currentOrder.OrderOverview.EscrowTeam.length; i++) {
        if (currentOrder.OrderOverview.EscrowTeam[i].Id?.includes('custom')) {
          mergedOrderDetails.OrderOverview?.EscrowTeam?.push(
            currentOrder.OrderOverview.EscrowTeam[i]
          );
        }
      }
    }

    const updatedSelectedSigners: ISigner[] = [];
    const updatedSelectedEscrowTeam: IEscrowMember[] = [];
    if (
      currentOrder.OrderDetails?.Signers &&
      currentOrder.OrderDetails.Signers.length
    ) {
      for (let i = 0; i < currentOrder.OrderDetails.Signers.length; i++) {
        if (currentOrder.OrderDetails.Signers[i].Id?.includes('custom')) {
          updatedSelectedSigners.push(currentOrder.OrderDetails.Signers[i]);
        }
        if (
          mergedOrderDetails.OrderOverview?.Signers &&
          mergedOrderDetails.OrderOverview.Signers.length
        ) {
          for (
            let i2 = 0;
            i2 < mergedOrderDetails.OrderOverview.Signers.length;
            i2++
          ) {
            if (
              mergedOrderDetails.OrderOverview.Signers[i2].Id ===
                currentOrder.OrderDetails.Signers[i].Id &&
              !currentOrder.OrderDetails.Signers[i].Id?.includes('custom')
            ) {
              updatedSelectedSigners.push(
                mergedOrderDetails.OrderOverview.Signers[i2]
              );
            }
          }
        }
      }
    }

    if (
      currentOrder.OrderDetails?.EscrowTeam &&
      currentOrder.OrderDetails.EscrowTeam.length
    ) {
      for (let i = 0; i < currentOrder.OrderDetails.EscrowTeam.length; i++) {
        if (currentOrder.OrderDetails.EscrowTeam[i].Id?.includes('custom')) {
          updatedSelectedEscrowTeam.push(
            currentOrder.OrderDetails.EscrowTeam[i]
          );
        }
        if (
          mergedOrderDetails.OrderOverview?.EscrowTeam &&
          mergedOrderDetails.OrderOverview.EscrowTeam.length
        ) {
          for (
            let i2 = 0;
            i2 < mergedOrderDetails.OrderOverview.EscrowTeam.length;
            i2++
          ) {
            if (
              mergedOrderDetails.OrderOverview.EscrowTeam[i2].Id ===
                currentOrder.OrderDetails.EscrowTeam[i].Id &&
              !currentOrder.OrderDetails.EscrowTeam[i].Id?.includes('custom')
            ) {
              updatedSelectedEscrowTeam.push(
                mergedOrderDetails.OrderOverview.EscrowTeam[i2]
              );
            }
          }
        }
      }
    }

    // move celluar phone first
    for (let i = 0; i < updatedSelectedSigners.length; i++) {
      updatedSelectedSigners[i].PhoneNumbers = moveToStart(
        updatedSelectedSigners[i].PhoneNumbers,
        'Type',
        'Cellular'
      );
    }

    for (let i = 0; i < updatedSelectedEscrowTeam.length; i++) {
      updatedSelectedEscrowTeam[i].PhoneNumbers = moveToStart(
        updatedSelectedEscrowTeam[i].PhoneNumbers,
        'Type',
        'Cellular'
      );
    }

    mergedOrderDetails.OrderDetails.Signers = updatedSelectedSigners;
    mergedOrderDetails.OrderDetails.EscrowTeam = updatedSelectedEscrowTeam;
    resolve(mergedOrderDetails);
  });
};
